
$(document).ready(function() {
  // Button click event
  $('.drawer-btn').click(function(e) {
    e.preventDefault();
    var targetContent = $(this).data('target');
    
    // Show side drawer
    $('#side-drawer').css('right', '0');

    // Show selected content and hide others
    $('.drawer-content').removeClass('active');
    $('#' + targetContent).addClass('active');

    // Add 'active' class to corresponding tab button
    $('.drawer-tab').removeClass('active');
    $('[data-content="' + targetContent + '"]').addClass('active');
  });

  // Drawer tab click event
  $('.drawer-tab').click(function() {
    var targetContent = $(this).data('content');

    // Show selected content and hide others
    $('.drawer-content').removeClass('active');
    $('#' + targetContent).addClass('active');

    // Add 'active' class to clicked tab button
    $('.drawer-tab').removeClass('active');
    $(this).addClass('active');
  });

   // Close side drawer when clicked outside
  $(document).on('click', function(e) {
    if (!$(e.target).closest('#side-drawer').length && !$(e.target).hasClass('drawer-btn')) {
      $('#side-drawer').css('right', '-400px');
    }
  });

   // Close side drawer
  $('#mobile-close-btn').click(function() {
    $('#side-drawer').css('right', '-100%');
  });
});


